import {loadApp} from './lib/opener';
loadApp();





// WEBPACK FOOTER //
// ./src/loader.ts